import {
    CreateReputationCard,
    DeleteReputationCard,
    QueryFileList,
    QueryReputationFile,
    QueryReputationsPage,
    SaveReputationFile,
    UpdateReputation,
    UpdateReputationCard,
    downloadFile,
    queryReturn,
    QueryAgeInfo,
    CreateCapital,
    UpdateCapital,
    DeleteCapital,
    QueryCapital,
    QueryActualReturn,
    QueryReturnPlan,
    UpdateReturnPlan,
    UpdateActualReturn,
    adjustReturn,
    QueryAdjustReturn,
    QueryAdjustList,
    UpdateAgeData,
    QueryReturnMark,
    SaveReturnMark,
    SubmitReturnMark,
    QueryActualMonth,
    SaveDocument,
    QueryAgingRiskList,
    QueryDocumentList,
    QueryConfirmList,
    ConfirmReturnMark,
    QueryCustomerMontList,
    QueryReturnAreaData,
    QueryReturnUserData,
    QueryReturnCustomerData,
    QueryCustomerIncomeInfo,
    QueryActualAreaData,
    QueryActualUserData,
    QueryActualCustomerData,
    QueryCreditData,
    GetReturnTarget,
    SaveReturnTargetMonth,
    UpdateReturnTargetOther,
    GetReturnTargetOther,
    SaveActualReturn,
    QueryReturnKeypoint,
    QueryReturnDiffcultReason,
    UpdateReturnDiffcultReason,
    SaveReturnDiffcultReason,
    GetReturnDiffcultReason,
    QueryReturnDiffcultPage,
    UpdateReturnDiffcult,
    SaveReturnDiffcult,
    DealReturnDiffcult,
    QueryDifficultTypeData,
    QueryDifficultPartyData,
    QueryDifficultPropData,
    QueryDifficultLevelData,
    QueryReturnAnly,
    QueryReturnAreaAbmut,
    QueryReturnUserAbmut,
    QueryReturnCustomerAbmut,
    QueryFocusCustomerPage,
    DeleteFocusCustomer,
    UpdateFocusCustomer,
    MarkFocusCustomer,
    QueryListPage,
    QueryShowPage,
    UpdateDataList,
    AddDataList,
    AddDataListBatch,
    QueryDatalistFinish,
    UpdateCancelFollowUp,
    DeleteMainDatalist,
    InsserRemarkFinish,
    QueryForecastRate,
    QueryReturnRate,
    QueryReturnUserRate,
    QueryReturnCustomerRate,
    QueryReturnFinishAreaRate,
    QueryReturnFinishUserRate,
    QueryReturnFinishCustomerRate,
    QueryNumAccountPeriod,
    QueryChargeAccountPeriod,
    QueryChargePrecent,
    SaveAccountPeriod,
    UpdateAccountPeriod,
    QueryHisAccount,
    SaveHisAccount,
    InsertHisAccount,
    QueryReturnCase,
    SaveReturnCase,
    UpdateReturnCase,
    DeleteReturnCase,
    QueryCaseInfo,
    QueryAreaPeriod,
    QueryCustomerPeriod,
    MarkAreaPeriod,
    QueryMarkRule,
    QueryCustomerRule,
    QueryCaseReturnDetail,
    QueryClientItem,
    QueryPrecentMain,
    QueryCustomerProperty,
    QuerySectionData,
    UpdateFinishList
} from '@/request/return';
import { AddDiffConditions, QueryDiffConditions, UpdateDiffConditions } from '../../request/return';

export default {
    namespace: true,
    state: {
        returnList: {},
        reputationList: {},
        actualReturn: {},
        returnPlan: {},
        actualMonth: {}
    },
    mutations: {
        SET_RETURN_LIST(state, returnList) {
            state.returnList = returnList;
        },

        SET_REPUTATION_LIST(state, reputationList) {
            state.reputationList = reputationList;
        },

        SET_ACTUAL_RETURN(state, actualReturn) {
            state.actualReturn = actualReturn;
        },

        SET_ACTUAL_RETURN_MONTH(state, actualMonth) {
            state.actualMonth = actualMonth;
        },

        SET_RETURN_PLAN(state, returnPlan) {
            state.returnPlan = returnPlan;
        },

        SET_RETURN_STATE(state, returnPlan) {
            state.returnPlan = returnPlan;
        },
        SET_ACTUAL_STATE(state, actualReturn) {
            state.actualReturn = actualReturn;
        }
    },
    actions: {
        UPDATE_RETURN_STATE({ commit }, payload) {
            commit('SET_RETURN_STATE', payload);
        },
        UPDATE_ACTUAL_STATE({ commit }, payload) {
            commit('SET_ACTUAL_STATE', payload);
        },
        QUERY_RETURN_LIST: async ({ commit }, payload) => {
            let res = await queryReturn(payload);
            if (res?.code == 200) {
                commit('SET_RETURN_LIST', res.data ?? {});
            } else {
                commit('SET_RETURN_LIST', {});
            }
            return res;
        },

        QUERY_REPUTATION_PAGE: async ({ commit }, payload) => {
            let res = await QueryReputationsPage(payload);
            if (res?.code == 200) {
                commit('SET_REPUTATION_LIST', res.data ?? {});
            }
            return res;
        },

        UPDATE_REPUTATION: async ({ commit }, payload) => {
            let res = await UpdateReputation(payload);
            return res;
        },

        SAVE_REPUTATION_FILE: async ({ commit }, payload) => {
            let res = await SaveReputationFile(payload);
            return res;
        },

        QUERY_REPUTATION_FILE: async ({ commit }, payload) => {
            let res = await QueryReputationFile(payload);
            return res;
        },

        CREATE_REPUTATION_CARD: async ({ commit }, payload) => {
            let res = await CreateReputationCard(payload);
            return res;
        },

        UPDATE_REPUTATION_CARD: async ({ commit }, payload) => {
            let res = await UpdateReputationCard(payload);
            return res;
        },

        DELETE_REPUTATION_CARD: async ({ commit }, payload) => {
            let res = await DeleteReputationCard(payload);
            return res;
        },

        QUERY_FILE_LIST: async ({ commit }, payload) => {
            let res = await QueryFileList(payload);
            return res;
        },

        DOWNLOAD_FILE: async ({ commit }, payload) => {
            let res = await downloadFile(payload);
            return res;
        },
        QUERY_AGE_INFO: async ({ commit }, payload) => {
            let res = await QueryAgeInfo(payload);
            return res;
        },

        UPDATE_AGE_DATA: async ({}, payload) => {
            let res = await UpdateAgeData(payload);
            return res;
        },

        CREATE_CAPITAL: async ({ commit }, payload) => {
            let res = await CreateCapital(payload);
            return res;
        },
        UPDATE_CAPITAL: async ({ commit }, payload) => {
            let res = await UpdateCapital(payload);
            return res;
        },

        DELETE_CAPITAL: async ({ commit }, payload) => {
            let res = await DeleteCapital(payload);
            return res;
        },

        QUERY_CAPITAL: async ({ commit }, payload) => {
            let res = await QueryCapital(payload);
            return res;
        },
        QUERY_ACTUAL_RETURN: async ({ commit }, payload) => {
            let res = await QueryActualReturn(payload);
            if (res?.code == 200) {
                commit('SET_ACTUAL_RETURN', res.data ?? {});
            }
            return res;
        },

        QUERY_ACTUAL_MONTH: async ({ commit }, payload) => {
            let res = await QueryActualMonth(payload);
            if (res?.code == 200) {
                commit('SET_ACTUAL_RETURN_MONTH', res.data ?? {});
            } else {
                commit('SET_ACTUAL_RETURN_MONTH', {});
            }
            return res;
        },

        UPDATE_ACTUAL_RETURN: async ({ commit }, payload) => {
            let res = await UpdateActualReturn(payload);
            return res;
        },

        QUERY_RETURN_QUOTA: async ({ commit }, payload) => {
            let res = await QueryReturnPlan(payload);
            if (res?.code == 200) {
                commit('SET_RETURN_PLAN', res.data ?? {});
            }
            return res;
        },

        UPDATE_RETURN_QUOTA: async ({ commit }, payload) => {
            let res = await UpdateReturnPlan(payload);
            return res;
        },

        ADJUST_RETURN: async ({ commit }, payload) => {
            let res = await adjustReturn(payload);
            return res;
        },

        QUERY_ADJUST_RETURN: async ({ commit }, payload) => {
            let res = await QueryAdjustReturn(payload);
            return res;
        },

        QUERY_ADJUST_LIST: async ({ commit }, payload) => {
            let res = await QueryAdjustList(payload);
            return res;
        },

        // 回款预填
        QUERY_RETURN_MARK: async ({}, payload) => {
            let res = await QueryReturnMark(payload);
            return res;
        },
        SAVE_RETURN_MARK: async ({}, payload) => {
            let res = await SaveReturnMark(payload);
            return res;
        },
        SUBMIT_RETURN_MARK: async ({}, payload) => {
            let res = await SubmitReturnMark(payload);
            return res;
        },

        SAVE_DOCUMENT: async ({}, payload) => {
            let res = await SaveDocument(payload);
            return res;
        },

        QUERY_AGING_RISK_LIST: async ({}, payload) => {
            let res = await QueryAgingRiskList(payload);
            return res;
        },

        QUERY_DOCUMENT_LIST: async ({}, payload) => {
            let res = await QueryDocumentList(payload);
            return res;
        },
        QUERY_RETURN_CONFIRM_LIST: async ({}, payload) => {
            let res = await QueryConfirmList(payload);
            return res;
        },

        SUMIT_CONFIRM_RETURN_MARK: async ({}, payload) => {
            let res = await ConfirmReturnMark(payload);
            return res;
        },

        QUERY_CUSTOMER_MONTH_LIST: async ({}, payload) => {
            let res = await QueryCustomerMontList(payload);
            return res;
        },

        // 综合分析
        QUERY_RETURN_AREA_DATA: async ({}, payload) => {
            let res = await QueryReturnAreaData(payload);
            return res;
        },

        QUERY_RETURN_USER_DATA: async ({}, payload) => {
            let res = await QueryReturnUserData(payload);
            return res;
        },
        QUERY_RETURN_CUSTOMER_DATA: async ({}, payload) => {
            let res = await QueryReturnCustomerData(payload);
            return res;
        },

        QUERY_CUSTOMER_INCOME_INFO: async ({}, payload) => {
            let res = await QueryCustomerIncomeInfo(payload);
            return res;
        },

        // 实际回款数据分析
        QUERY_ACTUAL_AREA_DATA: async ({}, payload) => {
            let res = await QueryActualAreaData(payload);
            return res;
        },
        QUERY_ACTUAL_USER_DATA: async ({}, payload) => {
            let res = await QueryActualUserData(payload);
            return res;
        },
        QUERY_ACTUAL_CUSTOMER_DATA: async ({}, payload) => {
            let res = await QueryActualCustomerData(payload);
            return res;
        },

        QUERY_CREDIT_DATA: async ({}, payload) => {
            let res = await QueryCreditData(payload);
            return res;
        },

        QUERY_DIFF_CONDITIONS: async ({}, payload) => {
            let res = await QueryDiffConditions(payload);
            return res;
        },

        ADD_DIFF_CONDITIONS: async ({}, payload) => {
            let res = await AddDiffConditions(payload);
            return res;
        },

        UPDATE_DIFF_CONDITIONS: async ({}, payload) => {
            let res = await UpdateDiffConditions(payload);
            return res;
        },
        // 回款计划新的编辑接口
        GET_RETURN_TATGET: async ({}, payload) => {
            let res = await GetReturnTarget(payload);
            return res;
        },
        SAVE_RETURN_TARGET_MONTH: async ({}, payload) => {
            let res = await SaveReturnTargetMonth(payload);
            return res;
        },
        UPDATE_RETURN_TARGET_OTHER: async ({}, payload) => {
            let res = await UpdateReturnTargetOther(payload);
            return res;
        },
        GET_RETURN_TARGET_OTHER: async ({}, payload) => {
            let res = await GetReturnTargetOther(payload);
            return res;
        },

        SAVE_ACTUAL_RETURN: async ({}, payload) => {
            let res = await SaveActualReturn(payload);
            return res;
        },

        QUERY_RETURN_KEYPOINT: async ({}, payload) => {
            let res = await QueryReturnKeypoint(payload);
            return res;
        },

        // 回款困难
        QUERY_RETURN_DIFFCULT_REASON: async ({}, payload) => {
            let res = await QueryReturnDiffcultReason(payload);
            return res;
        },

        UPDATE_RETURN_DIFFCULT_REASON: async ({}, payload) => {
            let res = await UpdateReturnDiffcultReason(payload);
            return res;
        },
        SAVE_RETURN_DIFFCULT_REASON: async ({}, payload) => {
            let res = await SaveReturnDiffcultReason(payload);
            return res;
        },
        GET_RETURN_DIFFCULT_REASON: async ({}, payload) => {
            let res = await GetReturnDiffcultReason(payload);
            return res;
        },

        QUERY_RETURN_DIFFCULT_PAGE: async ({}, payload) => {
            let res = await QueryReturnDiffcultPage(payload);
            return res;
        },
        UPDATE_RETURN_DIFFCULT: async ({}, payload) => {
            let res = await UpdateReturnDiffcult(payload);
            return res;
        },
        SAVE_RTURN_DIFFCULT: async ({}, payload) => {
            let res = await SaveReturnDiffcult(payload);
            return res;
        },
        DEAL_RETURN_DIFFCULT: async ({}, payload) => {
            let res = await DealReturnDiffcult(payload);
            return res;
        },

        // 困难分析
        QUERY_DIFFICULT_TYPE_DATA: async ({}, payload) => {
            let res = await QueryDifficultTypeData(payload);
            return res;
        },

        QUERY_DIFFICULT_PARTY_DATA: async ({}, payload) => {
            let res = await QueryDifficultPartyData(payload);
            return res;
        },

        QUERY_DIFFICULT_PROP_DATA: async ({}, payload) => {
            let res = await QueryDifficultPropData(payload);
            return res;
        },

        QUERY_DIFFICULT_LEVEL_DATA: async ({}, payload) => {
            let res = await QueryDifficultLevelData(payload);
            return res;
        },

        QUERY_RETURN_ANLY: async ({}, payload) => {
            let res = await QueryReturnAnly(payload);
            return res;
        },

        // 回款补缺
        QUERY_RETURN_AREA_ABMUT: async ({}, payload) => {
            let res = await QueryReturnAreaAbmut(payload);
            return res;
        },
        QUERY_RETURN_USER_ABMUT: async ({}, payload) => {
            let res = await QueryReturnUserAbmut(payload);
            return res;
        },
        QUERY_RETURN_CUSTOMER_ABMUT: async ({}, payload) => {
            let res = await QueryReturnCustomerAbmut(payload);
            return res;
        },

        QUERY_FOCUS_CUSTOMER_PAGE: async ({}, payload) => {
            let res = await QueryFocusCustomerPage(payload);
            return res;
        },

        MARK_FOCUS_CUSTOMER: async ({}, payload) => {
            let res = await MarkFocusCustomer(payload);
            return res;
        },

        DELETE_FOCUS_CUSTOMER: async ({}, payload) => {
            let res = await DeleteFocusCustomer(payload);
            return res;
        },
        UPDATE_FOCUS_CUSTOMER: async ({}, payload) => {
            let res = await UpdateFocusCustomer(payload);
            return res;
        },
        QUERY_DATA_LIST_PAGE: async ({}, payload) => {
            let res = await QueryListPage(payload);
            return res;
        },

        QUERY_SHOW_LIST_PAGE: async ({}, payload) => {
            let res = await QueryShowPage(payload);
            return res;
        },

        UPDATE_DATA_LIST: async ({}, payload) => {
            let res = await UpdateDataList(payload);
            return res;
        },

        UPDATE_FINISH_LIST: async ({}, payload) => {
            let res = await UpdateFinishList(payload);
            return res;
        },

        ADD_DATA_LIST: async ({}, payload) => {
            let res = await AddDataList(payload);
            return res;
        },
        ADD_DATA_LIST_BATCH: async ({}, payload) => {
            let res = await AddDataListBatch(payload);
            return res;
        },

        QUERY_DATALIST_FINISH: async ({}, payload) => {
            let res = await QueryDatalistFinish(payload);
            return res;
        },

        UPDATE_CANCEL_FOLLOWUP: async ({}, payload) => {
            let res = await UpdateCancelFollowUp(payload);
            return res;
        },

        DELETE_MAIN_DATALIST: async ({}, payload) => {
            let res = await DeleteMainDatalist(payload);
            return res;
        },

        INSERT_REMARK_FINISH: async ({}, payload) => {
            let res = await InsserRemarkFinish(payload);
            return res;
        },

        QUERY_FORECAST_RATE: async ({}, payload) => {
            let res = await QueryForecastRate(payload);
            return res;
        },

        QUERY_RETURN_AREA_RATE: async ({}, payload) => {
            let res = await QueryReturnRate(payload);
            return res;
        },
        QUERY_RETURN_USER_RATE: async ({}, payload) => {
            let res = await QueryReturnUserRate(payload);
            return res;
        },
        QUERY_RETURN_CUSTOMER_RATE: async ({}, payload) => {
            let res = await QueryReturnCustomerRate(payload);
            return res;
        },

        QUERY_RETURN_FINISH_AREA_RATE: async ({}, payload) => {
            let res = await QueryReturnFinishAreaRate(payload);
            return res;
        },
        QUERY_RETURN_FINISH_USER_RATE: async ({}, payload) => {
            let res = await QueryReturnFinishUserRate(payload);
            return res;
        },
        QUERY_RETURN_FINISH_CUSTOMER_RATE: async ({}, payload) => {
            let res = await QueryReturnFinishCustomerRate(payload);
            return res;
        },

        QUERY_NUM_ACCOUNT_PERIOD: async ({}, payload) => {
            let res = await QueryNumAccountPeriod(payload);
            return res;
        },

        SAVE_ACCOUNT_PERIOD: async ({}, payload) => {
            let res = await SaveAccountPeriod(payload);
            return res;
        },

        UPDATE_ACCOUNT_PERIOD: async ({}, payload) => {
            let res = await UpdateAccountPeriod(payload);
            return res;
        },

        QUERY_CHARGE_ACCOUNT_PERIOD: async ({}, payload) => {
            let res = await QueryChargeAccountPeriod(payload);
            return res;
        },
        QUERY_CHARGE_PRECENT: async ({}, payload) => {
            let res = await QueryChargePrecent(payload);
            return res;
        },
        QUERY_HIS_ACCOUNT: async ({}, payload) => {
            let res = await QueryHisAccount(payload);
            return res;
        },
        SAVE_HIS_ACCOUNT: async ({}, payload) => {
            let res = await SaveHisAccount(payload);
            return res;
        },
        INSERT_HIS_ACCOUNT: async ({}, payload) => {
            let res = await InsertHisAccount(payload);
            return res;
        },

        // 回款案件
        QUERY_RETURN_CASE: async ({}, payload) => {
            let res = await QueryReturnCase(payload);
            return res;
        },
        SAVE_RETURN_CASE: async ({}, payload) => {
            let res = await SaveReturnCase(payload);
            return res;
        },
        UPDATE_RETURN_CASE: async ({}, payload) => {
            let res = await UpdateReturnCase(payload);
            return res;
        },
        DELETE_RETURN_CASE: async ({}, payload) => {
            let res = await DeleteReturnCase(payload);
            return res;
        },

        QUERY_CASE_INFO: async ({}, payload) => {
            let res = await QueryCaseInfo(payload);
            return res;
        },

        QUERY_AREA_PERIOD: async ({}, payload) => {
            let res = await QueryAreaPeriod(payload);
            return res;
        },
        MARK_AREA_PERIOD: async ({}, payload) => {
            let res = await MarkAreaPeriod(payload);
            return res;
        },
        QUERY_CUSTOMER_PERIOD: async ({}, payload) => {
            let res = await QueryCustomerPeriod(payload);
            return res;
        },

        QUERY_MARK_RULE: async ({}, payload) => {
            let res = await QueryMarkRule(payload);
            return res;
        },
        QUERY_CUSTOMER_RULE: async ({}, payload) => {
            let res = await QueryCustomerRule(payload);
            return res;
        },

        // 诉讼立案后的回款明细
        QUERY_CASE_RETURN_DETAIL: async ({}, payload) => {
            let res = await QueryCaseReturnDetail(payload);
            return res;
        },
        // 客户属性占比
        QUERY_CLIENT_ITEM: async ({}, payload) => {
            let res = await QueryClientItem(payload);
            return res;
        },

        QUERY_CUSTOMER_PROPERTY: async ({}, payload) => {
            let res = await QueryCustomerProperty(payload);
            return res;
        },

        QUERY_SECTION_DATA: async ({}, payload) => {
            let res = await QuerySectionData(payload);
            return res;
        },

        //
        QUERY_PRECENT_MAIN: async ({}, payload) => {
            let res = await QueryPrecentMain(payload);
            return res;
        }
    }
};
